"use client"
import { useEffect } from 'react'
import { isMobileDevice } from '@/app/hooks/use-mobile'

// 视口宽度阈值：小于该值走移动版 /mm，大于等于走 PC 版
export const MM_BREAKPOINT = 1024

/**
 * PC 页面用：移动设备（手机/平板）或窗口宽度小于阈值时，自动跳转到对应的 /mm 页面。
 * 同时监听 resize，窗口被拖小时也会跳转。
 */
export function RedirectToMM({ href }: { href: string }) {
    useEffect(() => {
        const check = () => {
            if (isMobileDevice() || window.innerWidth < MM_BREAKPOINT) {
                window.location.replace(href)
            }
        }
        check()
        window.addEventListener('resize', check)
        return () => window.removeEventListener('resize', check)
    }, [href])
    return null
}

/**
 * /mm 页面用：非移动设备把窗口拉宽到阈值以上时，跳回对应的 PC 页面。
 * 仅监听 resize 拉宽动作，首次打开不跳转——这样桌面浏览器仍然可以直接预览 /mm 页面。
 */
export function RedirectToPC({ href }: { href: string }) {
    useEffect(() => {
        const check = () => {
            if (!isMobileDevice() && window.innerWidth >= MM_BREAKPOINT) {
                window.location.replace(href)
            }
        }
        window.addEventListener('resize', check)
        return () => window.removeEventListener('resize', check)
    }, [href])
    return null
}
